<template>
  <LineChart :width="width" :height="height" :chart-data="data" :options="options" />
</template>

<script>
import { mapGetters } from 'vuex';
import LineChart from '@/components/chart/LineChart';

export default {
  props: {
    list: Object,
    default() {
      return {
        labels: [],
        issuedLoans: [],
        paidLoans: [],
      };
    },
    width: {
      type: Number,
      default: 0,
    },
    height: {
      type: Number,
      default: 0,
    },
  },

  components: {
    LineChart,
  },

  computed: {
    ...mapGetters(['darkMode']),
    data() {
      const { labels, issuedLoans, paidLoans } = this.list;
      return {
        labels,
        datasets: [
          {
            label: this.$t('dashboard.loanIssued'),
            data: issuedLoans,
            borderWidth: 2,
            borderColor: '#3160D8',
            backgroundColor: 'transparent',
            pointBorderColor: '#3160D8',
            pointBackgroundColor: '#3160D8',
          },
          {
            label: this.$t('dashboard.loanPaid'),
            data: paidLoans,
            borderWidth: 2,
            borderDash: [2, 2],
            borderColor: '#BCBABA',
            backgroundColor: 'transparent',
            pointBorderColor: '#BCBABA',
            pointBackgroundColor: '#BCBABA',
          },
        ],
      };
    },
    options() {
      return {
        legend: {
          display: false,
        },
        scales: {
          xAxes: [
            {
              ticks: {
                fontSize: '12',
                fontColor: this.fontColor,
              },
              gridLines: {
                display: false,
              },
            },
          ],
          yAxes: [
            {
              ticks: {
                fontSize: '12',
                fontColor: this.fontColor,
                callback(value) {
                  return `${value}`;
                },
              },
              gridLines: {
                color: this.lineColor,
                zeroLineColor: this.lineColor,
                borderDash: [2, 2],
                zeroLineBorderDash: [2, 2],
                drawBorder: false,
              },
            },
          ],
        },
      };
    },
    fontColor() {
      return this.$store.getters.darkMode ? '#718096' : '#777777';
    },
    lineColor() {
      return this.$store.getters.darkMode ? '#718096' : '#D8D8D8';
    },
  },
};
</script>
